import * as React from 'react';
import { CustomButton, ButtonType, ModalBody, Modal, ModalSize, ModalFooter, CustomSubmitButton, HiddenInput } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { GeneralDentalReferralResponseApi } from "../../../../api/GeneralDentalReferralResponseApi";
import { IGeneralDentalReferralResponse} from '../../../../models/IGeneralDentalReferral';

interface IGeneralDentalReferralAnswerButton {
    generalDentalReferralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getGeneralDentalReferral: (id: number) => void;
}

export const GeneralDentalReferralAnswerButton: React.FunctionComponent<IGeneralDentalReferralAnswerButton> = ({ changeSuccessMessage, changeErrorMessage, getGeneralDentalReferral, generalDentalReferralId }) => {
    const auth = useAuth();
    const api = new GeneralDentalReferralResponseApi(auth);
    const [isAnswering, setIsAnswering] = React.useState<boolean>(false);
    
    const answerGeneralDentalReferral = (data: IGeneralDentalReferralResponse) => {
        setIsAnswering(true);
        api.saveGeneralDentalReferralAnswerAndClose(data,
            () => {
                document.getElementById("close-answer-generalDental-referral-modal")?.click();
                getGeneralDentalReferral(generalDentalReferralId);
                changeSuccessMessage("Remissvar har skickats och allmäntandvårdsremissen har avslutats");
            },
            (error) => {
                changeErrorMessage(error);
            },
            () => {
                setIsAnswering(false);
            })
    }

    return (
        <>
            <CustomSubmitButton onButtonSubmit={() => {document.getElementById("open-answer-generalDental-referral-modal")?.click();}}>Skicka remissvar och avsluta allmäntandvårdsremiss</CustomSubmitButton>
            <CustomButton buttonType={ButtonType.create} buttonText="" id="open-answer-generalDental-referral-modal" data-toggle="modal" data-target="#answer-generalDental-referral-modal" hidden />
            <Modal header="Skicka remissvar och avsluta remiss" id="answer-generalDental-referral-modal" modalSize={ModalSize.normal}>
                <ModalBody>
                    <HiddenInput name="generalDentalReferralId" value={generalDentalReferralId.toString()} />
                    <p>Är du säker på att du vill skicka remissvar och avsluta allmäntandvårdsremissen?</p>
                </ModalBody>
                <ModalFooter>
                    <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-answer-generalDental-referral-modal" />
                    <CustomSubmitButton onButtonSubmit={answerGeneralDentalReferral} isLoading={isAnswering}>Ja</CustomSubmitButton>
                </ModalFooter>
            </Modal>
        </>
    )
}